import React, { ChangeEvent } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { TrainingsDataTableQuery } from 'generated/resources/datatable.graphql'

import DataTable, { useDataTable } from 'modules/core/components/DataTable'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import PageLoading from 'modules/layout/components/Page/Loading'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EmptyStateAdmin } from './EmptyStateAdmin'

interface Props {
  search: string
  onSearch: (event: ChangeEvent<HTMLInputElement>) => void
  accessManagementSpace: boolean
  isEmpty: boolean
}

export const CatalogComponent = ({ search, onSearch, accessManagementSpace, isEmpty }: Props) => {
  const { navigation } = useNavigation()
  const data = useDataTable<TrainingsDataTableQuery>()

  if (data.queryResult.loading) return <PageLoading />

  return (
    <ResponsivePage.Body variant="full" showHeader={!isEmpty}>
      {isEmpty && accessManagementSpace && <EmptyStateAdmin />}
      {(!isEmpty || !accessManagementSpace) && (
        <Box flexGrow width="full">
          <Box gap="s8">
            <DataTable.HeadBar
              search={{
                placeholder: i18n.t('common.search'),
                value: search,
                onChange: onSearch,
              }}
              actions={
                <Button.Router to={navigation.trainings.catalog.list.new.fullPath()}>
                  {i18n.t('trainings.training_catalog.request_box.title')}
                </Button.Router>
              }
              disableExport
            />
            <DataTable.Table />
          </Box>
        </Box>
      )}
    </ResponsivePage.Body>
  )
}
